<template>
  <section class="tw:mx-auto">
    <div class="tw:md:max-w-(--tw-breakpoint-lg) tw:lg:max-w-(--tw-breakpoint-xl) tw:md:px-4 tw:mx-auto tw:my-12">
      <div
        class="tw:w-full tw:rounded-lg tw:border tw:border-gray-300 tw:grid tw:grid-cols-1 tw:auto-rows-fr tw:md:grid-cols-2"
      >
        <BaseLink
          v-for="(item, index) in faqItems"
          :key="item.key"
          class="tw:group tw:flex tw:items-center tw:relative tw:py-4 tw:lg:py-2 tw:min-h-[72px] tw:pl-4 tw:pr-16 tw:border-gray-300"
          :class="{
            'tw:border-b': index < faqItems.length - 1,
            'tw:lg:border-b-0': index >= faqItems.length - 2,
          }"
          :href="getLocalizedUrl(item.url)"
        >
          <span class="tw:flex tw:w-full">{{ $t(item.key) }}</span>
          <ChevronRight
            class="tw:bg-blue-700 tw:group-hover:bg-blue-800 tw:fill-white tw:rounded-full tw:h-[29px] tw:w-[29px] tw:absolute tw:right-5"
          />
        </BaseLink>
      </div>
    </div>
  </section>
</template>
<script setup>
import BaseLink from '@/components/BaseLink.vue'
import ChevronRight from '@/components/icons/ChevronRight.svg?component'
import { useSessionValues } from '@/composables/useSessionValues'

const faqItems = [
  {
    key: 'studio_plus_mp_faq_1',
    url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Business-Studio-explained',
  },
  {
    key: 'studio_plus_mp_faq_2',
    url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-Business-Studio-increases-your-property-s-accessibility-on-trivago',
  },
  {
    key: 'studio_plus_mp_faq_3',
    url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-to-cancel-a-subscription',
  },
  {
    key: 'studio_plus_mp_faq_4',
    url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-to-start-a-Business-Studio-subscription',
  },
  {
    key: 'studio_plus_mp_faq_5',
    url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Rate-Insights-explained',
  },
  {
    key: 'studio_plus_mp_faq_6',
    url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Accepted-payment-methods-for-premium-products',
  },
]
const { language } = useSessionValues()
const getLocalizedUrl = url => {
  if (!url) return ''
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}language=${language.value}`
}
</script>
<style scoped>
.faq {
  flex: 50% 0 0;
  border-bottom: 1px;
  border-color: var(--tw-color-gray-200);
  @media (max-width: 1024px) {
    flex: 100% 0 0;
    border: 0;
  }
}

.faq:nth-child(5) {
  @media (max-width: 1024px) {
    border-bottom: 1px solid;
    border-color: var(--tw-color-gray-200);
  }
}
.faq {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
  padding: 1rem;
  padding-right: 4rem;
}

.faq:hover {
  color: var(--tw-color-blue-800);
}

.faq:hover svg {
  background-color: var(--tw-color-blue-800);
}

.faq:nth-child(odd) {
  @media (max-width: 1024px) {
    margin-right: 0;
  }
}
.faq:nth-child(5),
.faq:nth-child(6) {
  border: 0;
}
</style>
